export enum FLAGS {
  FLOATING_HOME = 'floatingHome',
  HOME_MESSAGE = 'homeMessage',
  LOGIN_DEBUG = 'loginDebug', // Web Only
  PHOTO_REVEAL_SEE_MORE_BUTTON = 'photoRevealSeeMoreButton',
  LOGIN_FROM_QUERY_PARAMS_DEBUG = 'loginFromQueryParamsDebug',
  LEGAL_60_DAYS = 'legal60days',
}
